import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {MUIInput, MUISelect} from "../../utils/formUtils";
import React, {useEffect, useState} from "react";
import {Box, Button, Grid, MenuItem, Snackbar} from "@material-ui/core";
import axiosInstance from "../../api";
import Spinner from "../../components/Spinner";
import {makeStyles} from "@material-ui/core/styles";
import {Alert} from "@material-ui/lab";

const PREMIUM_ERROR_MESSAGE = 'Please enter a valid premium details.'
const COVA_ERROR_MESSAGE = 'Please enter a valid Coverage A details.'
const COVC_ERROR_MESSAGE = 'Please enter a valid Coverage C details.'
const validationSchema = yup.object({
    status: yup.string().typeError('Please select a status').required('Please select a status').nullable().notOneOf(['none'],'Please select a status'),
    //notes: yup.string().required('Please enter some notes'),
    premium: yup.number().when(
        'status', {
            is: 'TR_ST_OFFACC',
            then: yup.number().typeError(PREMIUM_ERROR_MESSAGE).positive(PREMIUM_ERROR_MESSAGE).required(PREMIUM_ERROR_MESSAGE),
            otherwise: yup.number().notRequired()
        }
    ),
    coverageA: yup.number().when(
        'status', {
            is: 'TR_ST_OFFACC',
            then: yup.number().typeError(COVA_ERROR_MESSAGE).positive(COVA_ERROR_MESSAGE).required(COVA_ERROR_MESSAGE),
            otherwise: yup.number().notRequired()
        }
    ),
    coverageC: yup.number().when(
        'status', {
            is: 'TR_ST_OFFACC',
            then: yup.number().typeError(COVC_ERROR_MESSAGE).positive(COVC_ERROR_MESSAGE).required(COVC_ERROR_MESSAGE),
            otherwise: yup.number().notRequired()
        }
    ),
    formType: yup.string().when(
        'status', {
            is: 'TR_ST_OFFACC',
            then: yup.string().required('Please choose the form type').nullable(),
            otherwise: yup.string().notRequired()
        }
    ),
    hurricaneDeductible: yup.string().when(
        'status', {
            is: 'TR_ST_OFFACC',
            then: yup.string().required('Please choose deductible for Hurricane').nullable(),
            otherwise: yup.string().notRequired()
        }
    ),
    allOtherPerilsDeductible: yup.string().when(
        'status', {
            is: 'TR_ST_OFFACC',
            then: yup.string().required('Please choose the deductible for other perils').nullable(),
            otherwise: yup.string().notRequired()
        }
    ),
    insuranceCompany: yup.string().when(
        'status', {
            is: (status) => status === 'TR_ST_OFFACC',
            then: yup.string().required('Please choose the Insurance Company').nullable().notOneOf(['none'],'Please choose the Insurance Company'),
            otherwise: yup.string().notRequired()
        }
    )
});
//TODO: for dev purposes, delete when done
/*const initState = {
    status: '',
    notes: '',
    premium: '1000',
    formType:'HO8',
    coverageA: '12000',
    coverageC: '12000',
    hurricaneDeductible: 'P_5',
    allOtherPerilsDeductible: 'P_9999',
    insuranceCompany: '1601'
};*/
const initState = {
    status: 'none',
    notes: '',
    premium: '',
    formType: '',
    coverageA: '',
    coverageC: '',
    hurricaneDeductible: '',
    allOtherPerilsDeductible: '',
    insuranceCompany: ''
};

const useStyles = makeStyles({
    container: {
        width: "100%",
        margin: "0 auto",
    },
});

export default function LeadStatusUpdate({leadAgentId, leadAgentData, getLeadUpdatedInformation, agentId, user}) {
    const classes = useStyles();
    const {handleSubmit, control, formState: {errors}} = useForm({
        shouldUnregister: true,
        resolver: yupResolver(validationSchema)
    });
    const [allStatusList, loadAllStatus] = useState([]);
    const [allFormTypes, loadAllFormTypes] = useState([]);
    const [allHurricaneDeductibleTypes, loaAllHurricaneDeductibleTypes] = useState([]);
    const [allPerilsDeductibleTypes, loadAllPerilsDeductibleTypes] = useState([]);
    const [eligibleCompanies, loadEligibleCompanies] = useState([]);
    const [formData, updateFormData] = useState(initState)
    const [showSpinner, setShowSpinner] = useState(false);
    const [acceptedOffer, setAcceptedOffer] = useState(false);
    const showOfferDetails = formData.status === 'TR_ST_OFFACC';
    const [snackBarSettings, setSnackBarSettings] = useState({show:false, message:null, variant:'success'});

    const onFormDataChange = (event) => {
        //if(event.target.name === 'status') reset()
        updateFormData((prevState) => ({
            ...prevState,
            [event.target.name]: event.target.value
        }));
    }

    useEffect(() => {
        updateFormData({
            ...formData,
            status: 'none',
            premium: leadAgentData.premium,
            formType: leadAgentData.formType,
            coverageA: leadAgentData.coverageA,
            coverageC: leadAgentData.coverageC,
            hurricaneDeductible: leadAgentData.hurricaneDeductible,
            allOtherPerilsDeductible: leadAgentData.perilsDeductible,
            insuranceCompany: 'none'
        });
        //setAcceptedOffer(leadAgentData.quoteStatus === 'TR_ST_OFFACC')
        loadEligibleCompaniesFromAPI();
        loadAppCodeDataFromAPI();
    }, []);

    const loadEligibleCompaniesFromAPI = () => {
        setShowSpinner(true);
        axiosInstance.get('agents/all-fma-eligible-companies', {params: {agentId: agentId}}).then((data) => {
            data = data.map(item => {
                return {label: item['companyName'], value: item['eligibleCompanyId']}
            })
            loadEligibleCompanies(data)
        }).finally(() => setShowSpinner(false))
    }

    const loadAppCodeDataFromAPI = () => {
        setShowSpinner(true)
        axiosInstance.get('common/get-app-codes-multi', {params: {categoryList: 'FORM_TYPE,HURRI_DEDUCT,PERILS_DEDUCT,STATUS'}}).then((data) => {
            loadAllPerilsDeductibleTypes(parseAppCodeResult(data, 'PERILS_DEDUCT'))
            loadAllFormTypes(parseAppCodeResult(data, 'FORM_TYPE'))
            loadAllStatus(parseAppCodeResult(data, 'STATUS'))
            loaAllHurricaneDeductibleTypes(parseAppCodeResult(data, 'HURRI_DEDUCT'))
        }).finally(() => setShowSpinner(false))
    }

    const parseAppCodeResult = (data, appCode) => {
        return data[appCode].map(item => {
            return {key: item["code"], value: item["description"]}
        })
    }

    const onSubmit = data => {
        setShowSpinner(true);
        data['leadAgentMapId'] = leadAgentId
        data['quoteStatus'] = data.status
        data['perilsDeductible'] = data.allOtherPerilsDeductible
        data['eligibleCompanyId'] = data.insuranceCompany
        data['leadId'] = leadAgentData?.leadId
        data['fmapRole'] = user.fmapRole
        data['legacyQuoteStatus'] = leadAgentData?.quoteStatus;
        axiosInstance.post('unauth/leads/updateLeadAgentInformation', data).then(() => {
            updateFormData({...formData, notes: ''})
            getLeadUpdatedInformation();
            setSnackBarSettings({show:true, message:'Lead status updated successfully.', variant:'success'});
        }).catch(() => {setSnackBarSettings({show:true, message:'An error occured while updating the status. Please try again later.', variant:'error'});}
        ).finally(() => setShowSpinner(false))
    }
    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarSettings({show:false, message:null, variant:''});
    };

    if (showSpinner) return <Spinner/>
    return (
        <>

            <form onSubmit={handleSubmit(onSubmit)} className={classes.container}>
                <Grid container alignItems="flex-start" spacing={2} m={3}>
                    <Grid item xs={12} sm={6} md={4}>
                        <MUISelect control={control} errors={errors} id="status" name="status"
                                   label="Status" disabled={acceptedOffer}
                                   value={formData?.status}
                                   defaultValue={formData?.status}
                                   onFormChange={onFormDataChange}>
                            <MenuItem key="none" value="none" disabled>--Select--</MenuItem>
                            {leadAgentData?.quoteStatus !== 'TR_ST_OFFACC' &&
                                <MenuItem key="TR_ST_OFFACC" value="TR_ST_OFFACC">Coverage Bound</MenuItem>
                            }
                            {(leadAgentData?.quoteStatus !== 'TR_ST_OFFNOACC' &&
                                    leadAgentData?.quoteStatus !== 'TR_ST_OFFNOACCM') &&
                                <MenuItem key="TR_ST_OFFNOACC" value="TR_ST_OFFNOACC">No Coverage Bound</MenuItem>
                            }
                        </MUISelect>
                    </Grid>
                </Grid>
                    {showOfferDetails &&
                    <Grid container alignItems="flex-start" spacing={2} m={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="premium" inputPrp={{maxLength: 20}}
                                      disabled={acceptedOffer}
                                      label="Premium"
                                      defaultValue={formData?.premium}
                                      value={formData?.premium}
                                      onInputChange={onFormDataChange} errors={errors}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUISelect control={control} errors={errors} id="formType" name="formType"
                                       label="Form Type" disabled={acceptedOffer}
                                       value={formData?.formType}
                                       defaultValue={formData?.formType}
                                       onFormChange={onFormDataChange}>
                                {
                                    allFormTypes.map(item => <MenuItem key={item["key"]}
                                                                       value={item["key"]}>{item["value"]}</MenuItem>)
                                }
                            </MUISelect>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="coverageA" inputPrp={{maxLength: 20}}
                                      disabled={acceptedOffer}
                                      label="Coverage A"
                                      defaultValue={formData?.coverageA}
                                      value={formData?.coverageA}
                                      onInputChange={onFormDataChange} errors={errors}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="coverageC" inputPrp={{maxLength: 20}}
                                      disabled={acceptedOffer}
                                      label="Coverage C"
                                      defaultValue={formData?.coverageC}
                                      value={formData?.coverageC}
                                      onInputChange={onFormDataChange} errors={errors}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUISelect control={control} errors={errors} id="hurricaneDeductible"
                                       name="hurricaneDeductible" label="Hurricane Deductible"
                                       disabled={acceptedOffer}
                                       value={formData?.hurricaneDeductible}
                                       defaultValue={formData?.hurricaneDeductible}
                                       onFormChange={onFormDataChange}>
                                {
                                    allHurricaneDeductibleTypes.map(item => <MenuItem key={item["key"]}
                                                                                      value={item["key"]}>{item["value"]}</MenuItem>)
                                }
                            </MUISelect>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUISelect control={control} errors={errors} id="allOtherPerilsDeductible"
                                       name="allOtherPerilsDeductible" label="All Other Perils Deductible"
                                       disabled={acceptedOffer}
                                       value={formData?.allOtherPerilsDeductible}
                                       defaultValue={formData?.allOtherPerilsDeductible}
                                       onFormChange={onFormDataChange}>
                                {
                                    allPerilsDeductibleTypes.map(item => <MenuItem key={item["key"]}
                                                                                   value={item["key"]}>{item["value"]}</MenuItem>)
                                }
                            </MUISelect>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUISelect control={control} errors={errors} id="insuranceCompany"
                                       name="insuranceCompany" label="Insurance Company"
                                       disabled={acceptedOffer}
                                       value={formData?.insuranceCompany}
                                       defaultValue={formData?.insuranceCompany}
                                       onFormChange={onFormDataChange}>
                                <MenuItem key="none" value="none" disabled>--Select--</MenuItem>
                                {
                                    eligibleCompanies.map(item => <MenuItem key={item["value"]}
                                                                            value={item["value"]}>{item["label"]}</MenuItem>)
                                }
                                <MenuItem key="Not in the list"
                                          value="-1000">Not in the list</MenuItem>
                            </MUISelect>
                        </Grid>
                    </Grid>
                    }

                <Grid container alignItems="flex-start" spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        {/*
                                <InputLabel htmlFor="notes" >Notes</InputLabel>
                                <MUITextareaAutosize control={control} errors={errors} id="notes" minRows={4}
                                                     style={{width: 600, maxWidth: '95%'}} placeholder="Notes"
                                                     name="notes" label="Notes" onInputChange={onFormDataChange}/>
*/}
                        <Box component="span" justifyContent="flex-start" alignItems="flex-start"
                             display="flex">
                            {!acceptedOffer &&
                            <Button type="submit" variant="contained" color="primary" name="btnSubmit">
                                Save
                            </Button>}
                        </Box>
                    </Grid>
                </Grid>

            </form>
            <Snackbar open={snackBarSettings.show} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert variant="filled" onClose={handleSnackBarClose} severity={snackBarSettings.variant}>{snackBarSettings.message}</Alert>
            </Snackbar>
        </>
    )
}
